import { Component } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-web',
  templateUrl: './guide-enterprise-web.component.html',
  styleUrls: ['./guide-enterprise-web.component.scss']
})
export class GuideEnterpriseWebComponent {

}
